import { render, staticRenderFns } from "./ManualSettings.vue?vue&type=template&id=603a9a0d&scoped=true&"
import script from "./ManualSettings.vue?vue&type=script&lang=ts&"
export * from "./ManualSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ManualSettings.vue?vue&type=style&index=0&id=603a9a0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603a9a0d",
  null
  
)

export default component.exports